import {VOICE_CHARACTERS} from '../../static/mod/modSchema.js';
import {bloodColorRamp, characterBloodColor} from '../../static/mod/bloodColors.js';

let colors;
const fallback = bloodColorRamp();
export function setBloodColorTheme(theme) {
    colors = VOICE_CHARACTERS.map(({skin}) => bloodColorRamp(characterBloodColor(skin, theme)));
}
setBloodColorTheme(null);

export function getCharacterBloodColors(skin) {
    return colors[skin] || fallback;
}
